
export default {
    name: 'DepositInProgress',
    props: {
        referenceId: {
            type: String,
            default: null,
        },
        text: {
            type: String,
            default: null,
        },
        amount: {
            type: [String, Number],
            default: '',
        },
        currency: {
            type: String,
            default: '',
        },
    },
}
